import axiosInstance from "../config/axios.config.ts";

export const singleFileUpload = async (file: File) => {
    const formData = new FormData()
    formData.append('image', file)
    const response = await axiosInstance.post('admin/upload-images', formData)
    if (response.data.success) {
        return response.data.data[0]
    }
}